module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-right-d11151a00247ceb4cbd0c0901790f1b0.svg";